(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["filatos-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.currentScript.closest('.shopify-section');
    const root = section ? section.querySelector('[data-product-section]') : document.querySelector('[data-product-section]');
    if (!root) return;
    const mainImage = root.querySelector('#FpMainImage');
    root.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (mainImage) mainImage.src = thumb.dataset.src;
        root.querySelectorAll('[data-gallery-thumb]').forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
    const quantity = root.querySelector('[data-qty-input]');
    root.querySelector('[data-qty-minus]')?.addEventListener('click', () => quantity.value = Math.max(1, Number(quantity.value || 1) - 1));
    root.querySelector('[data-qty-plus]')?.addEventListener('click', () => quantity.value = Number(quantity.value || 1) + 1);
    const selector = root.querySelector('[data-variant-select]');
    const price = root.querySelector('[data-product-price]');
    const button = root.querySelector('[data-add-button]');
    const label = root.querySelector('[data-add-label]');
    selector?.addEventListener('change', () => {
      const option = selector.options[selector.selectedIndex];
      price.textContent = option.dataset.price;
      const available = option.dataset.available === 'true';
      button.disabled = !available;
      label.textContent = available ? 'Add to bag' : 'Sold out';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
